<template>
    <div>
        <!-- responsive-header -->
        <responsive-header-component></responsive-header-component>
        <!-- responsive-header -->

        <div class="wrapper default">

            <!-- header -->
            <header class="main-header default">
            <div class="container">
                <header-component></header-component>
            </div>
            <navbar-component></navbar-component>
        </header>
            <!-- header -->
            <!-- main -->
            <main class="page-404">
                <div class="container text-center">
                    <div class="page-404-title">
                        <h1>صفحه‌ای که دنبال آن بودید پیدا نشد!</h1>
                    </div>
                    <div class="page-404-actions">
                        <router-link tag="a" to="/" class="page-404-action page-404-action--primary">صفحه اصلی</router-link>             
                    </div>
                    <div class="page-404-image">
                        <img src="assets/img/404.png">
                    </div>
                </div>
            </main>
            <!-- main -->
            <!-- footer -->
            <footer-component></footer-component>
            <!-- footer -->
        </div>
    </div>
</template>

<script>
    export default {
        beforeMount: function () {
            createPageTitle('خطای 404');
        }
    }
</script>

<style scoped>
   
</style>